import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function ProductSection() {
  const tomos = [{
    emoji: '📘',
    title: 'Tomo 1 — El Reloj Biológico',
    items: ['Por qué el colon tiene un reloj interno y cómo sincronizarlo', 'El reflejo gastro-cólico: la señal nerviosa que mueve el colon cada mañana', 'La Hora de Oro (6–9 AM): la ventana circadiana que nadie te explicó', 'El Vaso Sagrado y los 3 movimientos en cama que despiertan el sistema', 'Tu plan de 21 días para reconstruir el hábito desde cero'],
    color: 'border-blue-500/30'
  }, {
    emoji: '📗',
    title: 'Tomo 2 — Hidratación Osmótica',
    items: ['La diferencia entre tomar agua y hidratar osmóticamente el colon', 'El Trío Osmótico: Magnesio, Potasio y Sodio marino que anclan el agua', 'Las 5 infusiones osmóticas más potentes disponibles en Argentina', 'Las grasas lubricantes que hacen que el bolo resbale sin fricción', 'El protocolo de bebidas hora por hora para el máximo efecto matutino'],
    color: 'border-green-500/30'
  }, {
    emoji: '📙',
    title: 'Tomo 3 — La Escoba Inteligente',
    items: ['Por qué el salvado de trigo te está traicionando (y qué usarlo en cambio)', 'Las 12 Fibras Escoba: los alimentos que barren mecánicamente sin gas', 'El Semáforo de Fermentación: clasificación completa de fibras por índice de gas', 'El protocolo de introducción de 21 días para no inflamarte mientras mejorás', 'Las recetas y el plato escoba que garantizan el movimiento intestinal'],
    color: 'border-orange-500/30'
  }, {
    emoji: '📕',
    title: 'Tomo 4 — Ingeniería de la Evacuación',
    items: ['Por qué el inodoro occidental es anatómicamente incorrecto y cómo corregirlo', 'El banquito de 20 cm que cambia el ángulo anorrectal y elimina el esfuerzo', 'El Pujo Protegido: la presión correcta sin dañar el suelo pélvico', 'El Masaje I-L-U: la técnica manual que mueve el contenido físicamente', 'Posturas de yoga digestivo y el Protocolo de 10 Minutos en el trono'],
    color: 'border-red-500/30'
  }, {
    emoji: '📓',
    title: 'Tomo 5 — Libertad Diaria',
    items: ['El sistema de alerta temprana para detectar recaídas antes de que ocurran', 'La Regla del 80/20 que te da libertad social sin volver al punto de partida', 'El protocolo de viaje: avión, hotel, jet lag y cambio de huso horario', 'El ciclo menstrual y la menopausia: por qué hay semanas más difíciles y cómo manejarlas', 'El Método 1-1-1: el mantenimiento de 3 minutos diarios para el resto de tu vida'],
    color: 'border-gray-500/30'
  }];
  const includes = ['Plan diario listo para aplicar desde el primer día', 'Técnicas adaptadas a ingredientes de la feria y farmacia argentina', 'Checklist de los 7 puntos de verificación diaria', 'Tracker de progreso para medir la mejora semana a semana', 'Errores frecuentes y cómo evitarlos', 'Preguntas frecuentes respondidas directamente', 'Bibliografía científica en cada tomo'];
  return <section className="py-24 bg-brand-dark" data-id="element-224">
      <div className="container mx-auto px-4" data-id="element-225">
        <div className="max-w-5xl mx-auto" data-id="element-226">
          <div className="text-center mb-16" data-id="element-227">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-228">
              <h2 className="text-4xl md:text-5xl font-bold mb-4 text-brand-gold font-[Poppins,_sans-serif]" data-id="element-229">
                🏆 SISTEMA DESPERTAR LIVIANA™
              </h2>
              <p className="text-2xl text-white font-medium mb-2" data-id="element-230">
                5 Tomos + 5 Bonos — El sistema completo de 21 días
              </p>
              <p className="text-xl text-brand-light mb-2" data-id="element-231">
                El primer sistema de 4 pilares para el estreñimiento crónico
                femenino, 100% adaptado a Argentina
              </p>
              <p className="text-lg text-gray-400" data-id="element-232">300+ páginas.</p>
            </motion.div>
          </div>

          <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-233">
            📚 5 TOMOS COMPLETOS
          </h3>

          <div className="grid gap-6 mb-16" data-id="element-234">
            {tomos.map((tomo, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className={`bg-brand-black p-6 md:p-8 rounded-2xl border ${tomo.color} flex flex-col md:flex-row gap-6 items-start hover:bg-gray-900/50 transition-colors`} data-id="element-235">
                <div className="text-5xl shrink-0" data-id="element-236">{tomo.emoji}</div>
                <div data-id="element-237">
                  <h4 className="text-xl font-bold text-white mb-3" data-id="element-238">
                    {tomo.title}
                  </h4>
                  <ul className="space-y-2" data-id="element-239">
                    {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-2 text-gray-300" data-id="element-240">
                        <CheckCircle2 className="w-5 h-5 text-brand-light shrink-0 mt-0.5" data-id="element-241" />
                        <span data-id="element-242">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green/10 border border-brand-green/30 rounded-2xl p-8 md:p-10" data-id="element-243">
            <h4 className="text-xl font-bold text-white mb-6 text-center" data-id="element-244">
              Cada tomo incluye:
            </h4>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-245">
              {includes.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-246">
                  <CheckCircle2 className="w-6 h-6 text-brand-light shrink-0" data-id="element-247" />
                  <span className="text-gray-200" data-id="element-248">{item}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}